import OrderEditSate from './order-edit-state';

const orderEditInitialState: OrderEditSate = {
  orderDetails: undefined,
};

export default orderEditInitialState;
